const access = {
  entities: [
    { label: 't(Phone Numbers)', code: 'phone_numbers' }
  ], 
  rights: [] 
}

export default access
